export default {
    driver_performance_events_asset_id: "ID del Activo",
    driver_performance_events_asset_name: "Nombre del Activo",
    driver_performance_events_asset_no_asset_info: "No hay información disponible sobre el activo",
};